import React from 'react'
import './style.css'
import NotFound from '../../assets/img/404-error (1).png'

const Error404 =  () => {
    return (
        <div className="error-container"> 
            <div className="error-content">   
                <img src={NotFound} alt="Not Found" width="250" height="250" /> 
                <p className="error-header">Oops!</p>
                <p className="error-type">404 - PAGE NOT FOUND</p>
                <p className="error-desc">Halaman yang anda cari tidak ditemukan.</p>      
            </div>
        </div>
    )
}

export default Error404;